import api from '../helpers';
import { sortBy } from 'lodash';

export default {
  list: {
    key: 'fetchLanguages',
    query: () => {
      return api.get('/api/languages', {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return sortBy(data, (item) => item.label.toLowerCase());
    },
  },
};
